import React from 'react';
import './Kosmin.scss';

const Kosmin = () => {
    return (
        <section className="section section-kosmin">
            <div className="padding">
                <div className="line-through"></div>
                <div className="olives"></div>
                <div className="tomato"></div>
                <div className="sandwich"></div>
                <div className="container">
                    <div className="header"></div>
                    <div className="main-text"></div>
                </div>
            </div>
        </section>
    )
}

export default Kosmin



// WEBPACK FOOTER //
// ./src/Components/Screens/4_Kosmin/Kosmin.jsx